import { Injectable, signal } from '@angular/core';

/** The room that was opened. The top bar copies a link to this id. */
@Injectable({ providedIn: 'root' })
export class RoomLink {
  private readonly id = signal<string | null>(null);
  readonly roomId = this.id.asReadonly();

  set(roomId: string | null): void {
    const trimmed = roomId?.trim();
    this.id.set(trimmed ? trimmed : null);
  }
}
